// OrderPickupForm.jsx  (yalnızca üst özet; currency format YOK)
import React from 'react';
import { useLanguage } from '../../../../contexts/LanguageContext';

const OrderPickupForm = ({ headerInfo }) => {
    const { th } = useLanguage();
  return (
    <div className="p-fluid" style={{ maxWidth: 900 }}>
      <div
        className="surface-card p-3 border-round mb-4"
        style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 12 }}
      >
        <div>
          <div className="text-500 text-sm">{th('table.invoiceNo')}</div>
          <div className="font-medium">{headerInfo?.invoiceNo ?? '-'}</div>
        </div>
        <div>
          <div className="text-500 text-sm">{th('table.invoiceDate')}</div>
          <div className="font-medium">
            {headerInfo?.invoiceDate
              ? new Date(headerInfo.invoiceDate).toLocaleDateString('tr-TR')
              : '-'}
          </div>
        </div>
        <div>
          <div className="text-500 text-sm">{th('table.totalAmount')}</div>
          <div className="font-medium">{headerInfo?.totalAmount ?? '-'}</div>
        </div>
      </div>
    </div>
  );
};

export default OrderPickupForm;
